/**
 * @license
 * Copyright (c) 2025 Handsoncode. All rights reserved.
 */
import { FunctionPlugin, FunctionArgumentType } from "./plugin/FunctionPlugin.mjs";
import { EmptyValue } from "./InterpreterValue.mjs";
export { FunctionPlugin, FunctionArgumentType, EmptyValue };